<template>
    <div class="fanqizha-layer">
        <caseheader></caseheader>
        <div class="fz-container">
            <!-- 内容区域 -->
            <div class="fz-content">
                <!-- <component :is="currentStep" @nextStep="nextStep" /> -->
                 <casedata></casedata>
            </div>
        </div>
    </div>
</template>

<script>
import Caseheader from '@/components/layout/caseheader.vue';
import Casedata from '@/views/case/fanqizha/casedata.vue';

export default {
    name: '',
    components: {
        Caseheader,
        Casedata
    },
    props: {},
    data() {
        return {
            currentStep: 'Gerenyushouruxinxi'
        }
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        nextStep(step) {
            this.currentStep = step
        }
    }
}
</script>

<style scoped lang="less">
.fanqizha-layer {
    height: 100%;

    .fz-container {
        padding: 20px;
        display: flex;
        gap: 20px;
        height: calc(100% - 100px);
        width: calc(100% - 40px);

        .fz-content {
            flex: 1;
            background: rgba(5, 5, 5, 0.68);
            border-radius: 25px;
            color: #fff;
            padding: 30px;
            height: calc(100% - 60px);
        }
    }
}
</style>
